import { computed, provide, shallowRef, unref } from 'vue'

export const mobilePageNavigationKey = Symbol('mobilePageNavigation')

// 没有应用内历史时保持当前页，避免右滑离开应用。
export const goMobilePageBack = (router) => {
  if (router.options.history.state.back != null) router.back()
}

export function provideMobilePageNavigation(router) {
  const headers = shallowRef([])
  const mode = computed(() => {
    // 缓存恢复时父子 Header 的激活顺序可能变化，始终优先使用更深的路由。
    const current = headers.value.reduce((selected, entry) => {
      const depth = unref(entry.header.depth) || 0
      const selectedDepth = unref(selected?.header.depth) || 0
      return !selected || depth >= selectedDepth ? entry : selected
    }, null)
    return current?.header.showMenu.value ? 'menu' : 'back'
  })
  const goBack = () => goMobilePageBack(router)

  const registerHeader = (header) => {
    // 保留同时挂载的父子 Header，同层级时最后注册的页面优先处理手势。
    const entry = { header }
    headers.value = [...headers.value, entry]
    return () => {
      // 只移除本次注册；详情退出后恢复父页面，旧页面清理不影响新页面。
      headers.value = headers.value.filter((item) => item !== entry)
    }
  }

  provide(mobilePageNavigationKey, { registerHeader, goBack })
  return { mode, goBack }
}
